export default "__VITE_ASSET__ae6f3b90__"